import React, { Component } from 'react';
import './profile.css';


function ProfileAddDeal (props){

  return(
    <h1 className="main-h1 profile-h1">Gift Cards...Add A Deal!</h1>
)
}






export default ProfileAddDeal;



// WEBPACK FOOTER //
// ./src/profileadddeal.js